import BottomSheet from "../components/BottomSheet.js";
import SettingsForm from "../components/SettingsForm.js";

const LoginPromptDialog = (element, options = {}) => {
  const el = element;
  const opts = {
    ...options,
  };

  let settingsForm;

  const component = BottomSheet(el, {
    componentName: "LoginPromptDialog",
    closeOnBackdropClick: false,
    onOpen: async (title, prompt) => {
      settingsForm = SettingsForm(el.querySelector("#login-prompt-settings-form"), {
        onSubmit: (event, submitButton) => {
          event.preventDefault();
          if (submitButton.id === "login-button") {
            if (opts.onSubmit) opts.onSubmit();
          }
        },
      }).mount();

      settingsForm.enable();

      if (el) {
        el.querySelector(".bottom-sheet-header strong").innerHTML = title;
        settingsForm.form.querySelector("p").innerHTML = prompt;
      }
    },
    onClose: async () => {
      if (settingsForm) {
        settingsForm.unmount();
      }
    },
  });

  return component;
};

export default LoginPromptDialog;
